<nz-result [nzStatus]="'success'" [nzTitle]="messageToDisplay | locale" [nzSubTitle]="">
  <div nz-result-extra>
    <button nz-button nzType="default" [nzSize]="'large'" nzShape="round"
      *ngIf="moduleStructure.module.AdditionalInformationParsed.DisplayAddNewBtnAfterAdd" (click)="navigateToNew()">
      {{'Add new' | locale}}
    </button>
    <button nz-button nzType="default" [nzSize]="'large'" nzShape="round"
      *ngIf="moduleStructure.module.AdditionalInformationParsed.DisplayViewRecordBtnAfterAdd" (click)="viewRecord()">
      {{'View' | locale}}
    </button>
    <button nz-button nzType="default" [nzSize]="'large'" nzShape="round"
      *ngIf="moduleStructure.module.AdditionalInformationParsed.DisplayGoToListBtnAfterAdd" (click)="backToList()">
      {{'Back to list' | locale}}
    </button>
    <button nz-button nzType="default" [nzSize]="'large'" nzShape="round"
      *ngIf="moduleStructure.module.LayoutDefinitionId != null && moduleStructure.module.LayoutDefinitionId != 0"
      (click)="preview()">
      {{'Preview' | locale }}
    </button>
  </div>
</nz-result>
